function setTitle (title, vm) {
  if (typeof vm === 'object' && vm.params && vm.params.setTitle) {
    vm.params.setTitle(title)
  } else {
    document.title = title
    var iframe = document.createElement('iframe')
    iframe.style.visibility = 'hidden'
    iframe.style.display = 'none'
    iframe.style.width = '0'
    iframe.style.height = '0'
    iframe.style.border = 'none'
    iframe.src = '//static.udache.com/passenger/assets/images/pixel.png'
    iframe.onload = function () {
      setTimeout(function () {
        document.body.removeChild(iframe)
      }, 0)
    }
    document.body.appendChild(iframe)
  }
}

export {
  setTitle
}
